import { Button, Badge, Group, Text, Loader, Stack, Divider } from "@mantine/core";
import { useEffect, useState } from "react";
import { fetchFormVersions, restoreVersion } from "./formVersionApi";
import { toast } from "react-toastify";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

export default function FormVersionHistory({ formId, canRestore, onRestored }) {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [restoringId, setRestoringId] = useState(null);

  useEffect(() => {
    if (!formId) return;
    loadVersions();
  }, [formId]);

  const loadVersions = async () => {
    try {
      setLoading(true);
      const token = getCookie("token");
      const data = await fetchFormVersions(formId, token);
      setVersions(Array.isArray(data) ? data : []);
    } catch (err) {
    //   toast.error(err.message || "Failed to load version history");
      toast.error("Failed to load version history");
    } finally {
      setLoading(false);
    }
  };

  const handleRestore = async (versionId) => {
    const confirm = window.confirm(
      "This will restore the selected version as a NEW draft form.\n\nThe current form will remain unchanged."
    );
    if (!confirm) return;

    try {
      setRestoringId(versionId);
      const token = getCookie("token");
      const res = await restoreVersion(versionId, token);
      toast.success("Version restored as a new draft");
      onRestored(res.form.id);
    } catch (err) {
    //   toast.error(err.message || "Failed to restore version");
      toast.error("Failed to restore version");
    } finally {
      setRestoringId(null);
    }
  };

  if (loading) {
    return (
      <Group justify="center" py="md">
        <Loader size="sm" />
      </Group>
    );
  }

  if (versions.length === 0) {
    return (
      <Stack align="center" py="md">
        <Text size="sm" c="dimmed">
          No previous versions yet.
        </Text>
        <Text size="xs" c="dimmed">
          Versions are created automatically when you save or publish changes.
        </Text>
      </Stack>
    );
  }

  return (
    <Stack spacing="sm">
        <Divider mt="sm" />
      {versions.map((v, index) => (
        <div key={v.id}>
          <Group justify="space-between" align="center">
            <div>
              <Text size="sm">
                {new Date(v.createdAt).toLocaleString()}
              </Text>
              <Badge
                size="xs"
                color={v.isDraft ? "gray" : "green"}
                variant="light"
              >
                {v.isDraft ? "Draft version" : "Published version"}
              </Badge>
            </div>

            {canRestore && (
              <Button
                size="xs"
                variant="outline"
                loading={restoringId === v.id}
                onClick={() => handleRestore(v.id)}
              >
                Restore
              </Button>
            )}
          </Group>

          {index < versions.length - 1 && <Divider mt="sm" />}
        </div>
      ))}
    </Stack>
  );
}
